import axios from 'axios'
import router from '../../router'

/**
 * initial state
 */
const state = () => ({
  // todo
})

/**
 * getters
 */
const getters = {
  // todo
}

/**
 * mutations
 */
const mutations = {
  // todo
}

/**
 * actions
 */
const actions = {
  listQuotationCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API list quotation params ::', credentials)
      axios
        .post(process.env.VUE_APP_CAR_HISTORY, credentials)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  viewQuotationCarDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_CAR_VIEW + '/' + credentials.quotationId)
        .then((response) => {
          console.log('API view quotation car detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              if (Object.keys(response.data.data.car_projects).length === 0) {
                resolve('No content')
                console.error('No content')
                router.push({ name: 'history' })
              }
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          } else reject(response.data)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  listUserCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API list user params ::', credentials)
      axios
        .post(process.env.VUE_APP_CAR_USER_HISTORY, credentials)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
  DetailUserCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API Detail user params ::', credentials)
      axios
        .post(process.env.VUE_APP_CAR_USER_VIEW, credentials)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
  CreateUserCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API Create user params ::', credentials)
      axios
        .post(process.env.VUE_APP_CAR_USER_CREATE, credentials)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
  UpdateUserCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API Update user params ::', credentials)
      axios
        .post(process.env.VUE_APP_CAR_USER_UPDATE, credentials)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
  DeleteUserCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API Delete user params ::', credentials)
      axios
        .post(process.env.VUE_APP_CAR_USER_DELETE, credentials)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
  rejectCar(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API Reject params ::', credentials)
      const params = {
        remark: credentials.remark,
      }
      axios
        .post(process.env.VUE_APP_CAR_REJECT + '/' + credentials.id, params)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
  uploadFileCar(context, credentials) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('file', credentials.file)
      axios
        .post(process.env.VUE_APP_CAR_UPLOAD + '/' + credentials.id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          console.log(res)
          resolve(res)
        })
        .catch((err) => {
          console.log(err)
          reject(err)
        })
    })
  },
  confirmPolicy(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API confirm Policy params ::', credentials)
      axios
        .get(process.env.VUE_APP_CAR_CONFIRM_POLICY + '/' + credentials.id, {
          responseType: 'arraybuffer',
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
